const $ = require('jquery');

$('[id*="map-canvas-"]').each(function() {

    let $mapCanvas = $(this),
        mapID = $mapCanvas.data('map-id'),
        latitude = $mapCanvas.data('center-lat'),
        longitude = $mapCanvas.data('center-long'),
        zoom = $mapCanvas.data('zoom'),
        locations = $mapCanvas.data('locations') || [];

    // $mapCanvas.css('height', '100%');

    // if on mobile, decrease zoom level
    if (viewport().width < 768) {
        zoom = parseInt(zoom) - 1;
    }

    let map = Leaflet.map('map-canvas-'+mapID, {
        center: [latitude, longitude],
        zoom: zoom,
        scrollWheelZoom: false,
        tap: false
    });

    Leaflet.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
    }).addTo(map);

    // if map overlay is present, pan map left on desktop or up on mobile
    if ($mapCanvas.closest('.map-embed').find('.map-embed__window').length > 0) {
        if (viewport().width > 767) {
            let offset = map.getSize().x * 0.1;
            map.panBy(new L.Point(offset, 0), {animate: false});
        } else { // mobile
            let offset = map.getSize().y * 0.15;
            map.panBy(new L.Point(0, offset), {animate: false});
        }
    }

    let pin_icon = Leaflet.icon({
        iconUrl: mapIconPath,
        iconSize: [50, 50],
        iconAnchor: [25, 50],
        popupAnchor: [0, -45]
    });

    for (const location of locations) {
        if (location.lat && location.lon) {

            let myMarker;

            // create marker
            myMarker = Leaflet.marker([location.lat, location.lon], {icon: pin_icon});

            // add marker id property (corresponding with locations-list location items)
            myMarker.customMarkerID = 'location-marker-' + location.ID;

            // add marker to map
            myMarker.addTo(map).bindPopup(location.popup_content);

            if (location.open_popup) {
                myMarker.openPopup();
            }
        }
    }

    // when location items in locations-list are clicked, open corresponding popup
    $('.locations__list').on('click', '.location__focus-marker', function () {
        let markerID = $(this).data('marker-id');

        $.each(map._layers, function () {
            if (this.customMarkerID === markerID) {
                this.openPopup();
                map.setView(this._latlng, 12); // (panTo, zoom)
            }
        });
    });
});